module.exports = require("@swa-ui/analytics");